require('normalize.css/normalize.css');
require('styles/bootstrap/css/bootstrap.min.css');
require('styles/bootstrap/css/bootstrap-theme.min.css');
require('styles/App.css');

import React from 'react';
import Header from './Header.js'
import Home from './Home.js'
import Footer from './Footer.js'
import Cookies from 'js-cookie'
import 'whatwg-fetch'

// import createBrowserHistory from 'history/createBrowserHistory'

// const history = createBrowserHistory()

// history.listen(location => {
//   const pathChanged = prevLocation.pathname !== location.pathname;
//   const hashChanged = prevLocation.hash !== location.hash;
//   if (pathChanged || hashChanged) window.scrollTo(0, 0);
//   prevLocation = location;
// });

class AppComponent extends React.Component {
  constructor(props) {
    super(props)
    this.dismissCookieWarning = this.dismissCookieWarning.bind(this);
    let cookieBool = Cookies.get('alertWasRead') ? true : false;
    this.state = {
      alertWasRead: cookieBool
    }
  }

  dismissCookieWarning() {
    Cookies.set('alertWasRead', true, { expires: 30 })
    this.setState({
      alertWasRead: true
    })
  }

  render() {
    return (
      <div className="site-container">
        <Header />
        <Home />
        <Footer />
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js